import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import { Helmet } from 'react-helmet-async'
import FAQ from './FAQ'
import InsightsMarket from './Insights&Market'
import TradeAnywhere from './TradeAnywhere'
import ExploreOurProducts from './ExploreOurProducts'
import MostTrendingTokens from './MostTrendingTokens'
import HeroSection from './HeroSection'
import Config from '../../core/config'
import { getHomeMarketsTwoCurrency } from '../../core/services/all.api'
import { makeRequest } from '../../core/services/v1/request'
import PageTitleDes from '../../core/support/PageTitleDes'

function HomeV3() {
  const [marketValues, setMarketValues] = useState({
    BTC: [],
    INR: [],
    V2USDT: [],
  })
  const [usdtValues, setUsdtValues] = useState({})

  useEffect(() => {
    const getHomeMarketsCall = async () => {
      const params = {
        url: `${Config.V3_API_URL}trade/getMarketsBannerUSDT`,
        method: 'POST',
        data: { pairs: ['BTC_USDT', 'SOL_USDT'] },
      }
      const [resp, response] = await Promise.all([
        getHomeMarketsTwoCurrency({}),
        makeRequest(params),
      ])
      if (resp) {
        const { data = {}, status = false } = resp
        if (status) {
          setMarketValues(() => data)
        }
      }
      if (response.status) {
        setUsdtValues(() => response.data)
      }
    }
    getHomeMarketsCall()
  }, [])

  return (
    <Box component='main'>
      <PageTitleDes title={`Best Crypto Exchange Platform in India | Buy & Sell Cryptocurrency`} description={`Trade Bitcoin, Ethereum, and top cryptocurrencies securely on our advanced exchange platform. Fast transactions, low fees, and user-friendly experience.`} />
      {/* <Helmet>
        <link rel='canonical' href='https://uniticexchange.com/' />
        <meta
          name='description'
          content='The India s First exchange providing spot and future signals'
        />
        <meta name='description' content='Buy USDT' />
        <meta name='description' content='BUY OTC USDT Withdrawal' />
        <meta name='description' content='USDT Withdrawal, OTC USDT' />
        <meta name='description' content='btc price' />
        <meta name='description' content='ethereum price' />
        <meta
          name='description'
          content='market capitalization in cryptocurrency'
        />
        <meta name='description' content='Future Trading' />
        <meta name='description' content='btc price prediction' />
        <meta name='description' content='FIU Registered Crypto Exchange' />
        <meta name='description' content='Indian best crypto exchange' />
        <meta name='description' content='Indian crypto exchange' />
        <meta
          name='description'
          content='Best crypto exchange in India for beginners'
        />
        <meta
          name='description'
          content='Top Indian cryptocurrency exchanges'
        />
      </Helmet> */}
      <Box>
        <Box className='container'></Box>
        <HeroSection
          marketValues={marketValues}
          usdtValues={usdtValues}
          marketCurrency={'INR'}
        />
        <MostTrendingTokens marketValues={marketValues} />
        <ExploreOurProducts />
        <TradeAnywhere />
        <InsightsMarket />
        <FAQ />
      </Box>
    </Box>
  )
}

export default HomeV3
